import React from "react";
import CloseIcon from "@mui/icons-material/Close";

const icons = ["🏆", "🎯", "🚀", "⭐️", "🔥", "💪"];

const DialogModal = ({ setSelectedDay, selectedDay, setShowModal, showModal, selectedDayProgress, themeContext }) => {
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedDay(null);
  };
  const isDark = themeContext === 'dark';
  return (
    <>
      {showModal && (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 transition-opacity duration-300 font-['Poppins']">
          <div className={`relative w-[90%] max-w-lg rounded-2xl shadow-2xl p-6 border animate-fade-in ${
            isDark 
              ? 'bg-[#0F1115] border-[#232733]' 
              : 'bg-white border-[#E6E6EA]'
          }`}>
            <button
              className={`absolute top-3 right-3 transition rounded-full p-1 ${
                isDark 
                  ? 'text-[#E7EAF0] hover:text-white hover:bg-[#171A20]' 
                  : 'text-[#2E2E2E] hover:text-black hover:bg-gray-100'
              }`}
              onClick={handleCloseModal}
              aria-label="Close modal"
            >
              <CloseIcon fontSize="small" />
            </button>

            <h2 className={`text-md sm:text-md lg:text-2xl md:text-xl font-semibold mb-4 text-center font-['Poppins'] ${
              isDark ? 'text-[#E7EAF0]' : 'text-[#2E2E2E]'
            }`}>
              My Growing List of Victories 
            </h2>

            <div className="max-h-[60vh] overflow-y-auto px-2 custom-scrollbar space-y-4">
              {selectedDayProgress && Object.keys(selectedDayProgress).length > 0 ? (
                Object.entries(selectedDayProgress)
                  .sort(([a], [b]) => Number(a) - Number(b))
                  .flatMap(([day, entries]) =>
                    entries.map((entry, i) => {
                      // Check if victory_text exists and is an array
                      if (!entry.victory_text) {
                        return null;
                      }
                      
                      // Handle different data types for victory_text
                      let victoryTexts = [];
                      if (Array.isArray(entry.victory_text)) {
                        victoryTexts = entry.victory_text;
                      } else if (typeof entry.victory_text === 'string') {
                        victoryTexts = [entry.victory_text];
                      } else {
                        return null;
                      }
                      
                      return victoryTexts.map((text, idx) => (
                        <div
                          key={`${day}-${i}-${idx}`}
                          className={`rounded-2xl p-4 shadow-sm flex items-start space-x-3 border ${
                            isDark 
                              ? 'bg-[#171A20] border-[#232733] text-[#E7EAF0]' 
                              : 'bg-[#F4F4F6] border-[#E6E6EA] text-[#2E2E2E]'
                          }`}
                        >
                          <span className="text-lg flex-shrink-0 mt-0.5">{icons[(i + idx) % icons.length]}</span>
                          <p className={`text-sm font-['Poppins'] leading-relaxed ${
                            isDark ? 'text-[#E7EAF0]' : 'text-[#2E2E2E]'
                          }`}>{text}</p>
                        </div>
                      ));
                    }).filter(Boolean)
                  ).filter(Boolean)
              ) : (
                <p className={`text-sm text-center py-8 font-['Poppins'] ${
                  isDark ? 'text-[#E7EAF0] opacity-70' : 'text-gray-500'
                }`}>
                  As you go through the 42-day journey, all victories celebrated will be added here.
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DialogModal;